import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { FabricationVendorForm, FabricationVendorFormType } from './FabricationVendorForm'
import { getFabricationVendorById, updateFabricationVendor } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useParams } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Fabrication Vendors',
    path: '/system/fabrication-vendors'
  },
  {
    label: 'Edit',
    isCurrentPage: true
  }
]

export const EditFabricationVendor = () => {
  const { vendorId } = useParams()
  const { createToast } = useAppContext()
  const [vendor, setVendor] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const row = await getFabricationVendorById(vendorId)
        setVendor(row)
      } catch (err) {
        createToast('error', 'Error', err.response.data)
      }
    }
    load()
  }, [])

  const handleEdit = async (form) => {
    setIsSubmitting(true)

    try {
      const row = await updateFabricationVendor(vendorId, {
        name: form.name,
        contact: form.contact,
        email: form.email,
        phone: form.phone,
        address: form.address,
        city: form.city,
        state: form.state,
        zip: form.zip
      })
      if (row) {
        setVendor(row)
        createToast('success', 'Fabrication vendor updated.')
      } else {
        createToast('error', 'Failed to update.')
      }
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Edit Fabrication Vendor</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <FabricationVendorForm
              type={FabricationVendorFormType.Edit}
              onSubmit={handleEdit}
              isSubmitting={isSubmitting}
              initialForm={vendor}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
